/** Усі варіанти, крім готівки — у формі/контролері можлива націнка %. */
export function purchaseUsesCashlessMarkup(paymentType) {
    return Boolean(paymentType && paymentType !== "cash");
}

export function purchasePaymentTypeLabel(paymentType) {
    switch (paymentType) {
        case "cash":
            return "Готівка";
        case "card":
            return "Картка";
        case "fop_requisites":
            return "За реквізитами на ФОП";
        case "noncash":
            return "Безготівка";
        default:
            return "—";
    }
}
